export default __webpack_public_path__ + "static/media/ssap.a0eee2ec.svg";